/* eslint-disable prettier/prettier */
import { Utils } from 'mw-style-react';
import {
  URL_REGEXP,
  MAILTO_REGEX,
  RE_UUDID_GLOBAL,
} from '@control-front-end/common/constants/regExp';
// eslint-disable-next-line import/no-cycle
import AppUtils from '../utils';

export default {
  removeHtmlTags(str) {
    str = str || '';
    return str.replace(/<[^>]*>/g, '');
  },

  divToN(str) {
    str = str || '';
    return str.replace(/<div>/gi, '\n').replace(/<\/div>/gi, '');
  },

  correctImgSize(el, callback) {
    const img = new Image();
    const src = el.getAttribute('src');
    img.src = src;
    const maxWidth = Math.round(window.innerWidth * 0.85);
    const maxHeight = Math.round(window.innerHeight * 0.85);
    img.onload = () => {
      const { naturalWidth } = img;
      const { naturalHeight } = img;
      const ratio = Math.min(
        maxWidth / naturalWidth,
        maxHeight / naturalHeight
      );
      callback({
        width: Math.round(naturalWidth * ratio),
        height: Math.round(naturalHeight * ratio),
        naturalWidth,
        naturalHeight,
        src,
      });
    };
  },

  hilightLinks(text = '') {
    text = text.toString();
    // исключаем ссылки уже обернутые в тег <a>
    const replacePattern1 = new RegExp(`(href=[\\"']|s*)${URL_REGEXP}`, 'gim');
    text = text.replace(replacePattern1, (arg1, arg2, arg3) =>
      arg2.length
        ? arg1
        : `<a rel="nofollow noreferrer noopener" class="ext__link" href="${arg3}" target="_blank">${arg3}</a>`.replace(
            '&#8203;',
            ''
          )
    );
    const replacePattern2 = new RegExp(MAILTO_REGEX, 'gim');
    text = text.replace(
      replacePattern2,
      ' <a class="hcc" href="mailto:$1@$2.$3">$1@$2.$3</a> '
    );
    return text;
  },

  hilightTags(str, handle, tags = []) {
    function wrapTag(element, regex, url) {
      const document = element.ownerDocument;
      const nodes = [];
      const f = (n) =>
        n.parentNode.nodeName !== 'A'
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      const nodeIterator = document.createNodeIterator(
        element,
        NodeFilter.SHOW_TEXT,
        f,
        false
      );
      let text = '';
      let node;
      // eslint-disable-next-line
      while ((node = nodeIterator.nextNode())) {
        nodes.push({
          textNode: node,
          start: text.length,
        });
        text += ` ${node.nodeValue}`;
      }

      if (!nodes.length) return;

      let match;
      // eslint-disable-next-line
      while ((match = regex.exec(text))) {
        const matchLength = match[0].length;
        if (!matchLength) continue;

        for (let i = 0; i < nodes.length; i += 1) {
          node = nodes[i];
          const nodeLength = node.textNode.nodeValue.length;
          // Skip nodes before the match
          if (node.start + nodeLength <= match.index) continue;
          // Break after the match
          if (node.start >= match.index + matchLength) break;
          // Split the start node if required
          if (node.start < match.index) {
            nodes.splice(i + 1, 0, {
              textNode: node.textNode.splitText(match.index - node.start),
              start: match.index,
            });
            continue;
          }
          // Split the end node if required
          if (node.start + nodeLength > match.index + matchLength) {
            nodes.splice(i + 1, 0, {
              textNode: node.textNode.splitText(
                match.index + matchLength - node.start
              ),
              start: match.index + matchLength,
            });
          }
          const aNode = document.createElement('a');
          aNode.className = 'tag';
          aNode.href = url;

          node.textNode.parentNode.replaceChild(aNode, node.textNode);
          aNode.appendChild(node.textNode);
        }
      }
    }

    const baseEl = document.createElement('body');
    baseEl.innerHTML = str;

    for (const tag of tags) {
      try {
        const replacePattern = new RegExp(
          `(?:[\\s,.:;"']|^)(${tag.name})(?=[\\s,.:;"']|$)`,
          'gim'
        ); // NOSONAR
        const url = handle(tag.name);
        wrapTag(baseEl, replacePattern, url);
      } catch (e) {
        // console.error(`Error tag ${tag.name}`); // eslint-disable-line
      }
    }

    return baseEl.innerHTML;
  },

  removeBbCode(text = '') {
    if (!text) return text;
    const rImg = /\[img=(.*?)\](.*?)\[\/img\]/gi; // NOSONAR
    const rUser = /\[user=(.*?)\](.*?)\[\/user\]/gi; // NOSONAR
    const rChip =
      /\[(event|graph|actor)=(.*?)\](.*?)\[\/(event|graph|actor)\]/gi; // NOSONAR

    function chipReplacer(match, p1, p2, p3) {
      return p3;
    }

    text = text
      .replace(rImg, '')
      .replace(rUser, '@$2')
      .replace(rChip, chipReplacer);
    return text;
  },

  removeImgBbCodeById(text, id) {
    text = text || '';
    const rImg = /\[img=(.*?)\](.*?)\[\/img\]/gi; // NOSONAR

    function imgReplacer(match, p1) {
      return p1 === id ? '' : match;
    }

    text = text.replace(rImg, imgReplacer);
    return text;
  },

  htmlToBbCode(text = '') {
    const rImg = /<img.?id="(.*?)".?src="(.*?)alt="(.*?)".*?>/gi; // NOSONAR
    const rEvent = /<a.?class="event__descr__link".*?href="(.*?)>(.*?)<\/a>/gi; // NOSONAR
    const rChip = /<a.*?data-chip="(.*?)".*?href="(.*?)>(.*?)<\/a>/gi; // NOSONAR
    const rMark = /<mark.*?id="(.*?)".*?data-chip="(.*?)">(.*?)<\/mark>/gi; // NOSONAR

    function imgReplacer(match, p1, p2, p3) {
      return `[img=${p1}]${p3}[/img]`;
    }

    function eventReplacer(match, p1, p2) {
      const eventId = p1.replace('"', '').split('/')[4];
      return `[event=${eventId}]${p2}[/event]`;
    }

    function chipReplacer(match, p1, p2, p3) {
      const srcParts = p2.replace('"', '').split('/');
      let objId;
      if (p1 === 'graph') {
        objId = srcParts[4];
      } else if (p1 === 'graphLayer') {
        objId = `${srcParts[4]}_${srcParts[6]}`;
      } else {
        objId = srcParts[srcParts.length - 1];
      }
      return `[${p1}=${objId}]${p3}[/${p1}]`;
    }

    function markReplacer(match, p1, p2, p3) {
      return `[${p2}=${p1}]${p3}[/${p2}]`;
    }

    text = text
      .replace(rMark, markReplacer)
      .replace(rImg, imgReplacer)
      .replace(rEvent, eventReplacer)
      .replace(rChip, chipReplacer);
    return text;
  },

  bbCodeToHtml(text = '', accId = '', chip = false) {
    text = text.toString();
    const rImg = /\[img=(.*?)\](.*?)\[\/img\]/gi; // NOSONAR
    const rUser = /\[user=(.*?)\](.*?)\[\/user\]/gi; // NOSONAR
    const rEvent = /\[event=(.*?)\](.*?)\[\/event\]/gi; // NOSONAR
    const rGraph = /\[graph=(.*?)\](.*?)\[\/graph\]/gi; // NOSONAR
    const rGraphLayer = /\[graphLayer=(.*?)\](.*?)\[\/graphLayer\]/gi; // NOSONAR
    const rActor = /\[actor=(.*?)\](.*?)\[\/actor\]/gi; // NOSONAR
    const rApp = /\[application=(.*?)\](.*?)\[\/application\]/gi; // NOSONAR

    function makeLink({ url, title, type = 'event' }) {
      return `<a data-chip="${type}" rel="nofollow noreferrer noopener" contenteditable="false" target="_blank" href="${url}">${title}</a>`;
    }

    function makeMark({ id, nick }) {
      return `<mark id="${id}" data-chip="user">${nick}</mark>`;
    }

    function imgReplacer(match, p1, p2) {
      const url = AppUtils.makeAppUrl(`/download/${p1}`);
      return `<img id="${p1}" src="${url}" alt="${p2}">`;
    }

    function imgReplacerChip(match, p1, p2) {
      return `<div class="event__descr__chip" id="img__${p1}">
            <i class="event__descr__chip__icon" id="img__${p1}">
              <svg width="24" height="24" viewBox="0 0 24 24" id="img__${p1}">
                <path
                  id="img__${p1}"
                  d="M14.951 15.073L10 8 3 18h18l-4-6-2.049 3.073zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm13 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
              </svg>
            </i>
            <span id="img__${p1}" class="event__descr__chip__label" style="color: inherit;">${p2}</span>
        </div>`;
    }

    function userReplacer(match, p1, p2) {
      return makeMark({ id: p1, nick: p2 });
    }

    function eventReplacer(match, p1, p2) {
      const uudidRe = new RegExp(`(${RE_UUDID_GLOBAL})`);
      const isEventActor = uudidRe.test(p1);
      const url = `/actors_graph/${accId}/view/${p1}`;
      return isEventActor ? makeLink({ url, title: p2, type: 'event' }) : p2;
    }

    function graphReplacer(match, p1, p2) {
      const url = `/actors_graph/${accId}/graph/${p1}/layers/0`;
      return makeLink({ url, title: p2, type: 'graph' });
    }

    function graphLayerReplacer(match, p1, p2) {
      const [graphFolderId, layerId] = p1.split('_');
      const url = `/actors_graph/${accId}/graph/${graphFolderId}/layers/${layerId}`;
      return makeLink({ url, title: p2, type: 'graphLayer' });
    }

    function actorReplacer(match, p1, p2) {
      const url = `/actors_graph/${accId}/graph/0/actors/${p1}`;
      return makeLink({ url, title: p2, type: 'actor' });
    }

    function appReplacer(match, p1, p2) {
      const url = `/script/${accId}/view/${p1}/production/index`;
      return makeLink({ url, title: p2, type: 'script' });
    }

    text = text
      .replace(rImg, chip ? imgReplacerChip : imgReplacer)
      .replace(rEvent, eventReplacer)
      .replace(rGraph, graphReplacer)
      .replace(rGraphLayer, graphLayerReplacer)
      .replace(rActor, actorReplacer)
      .replace(rApp, appReplacer)
      .replace(rUser, userReplacer);
    return text;
  },

  smileToHtml(str) {
    if (!str) return str;
    const tSpan = /\[span(.*?)\](.*?)\[\/span\]/gi; // NOSONAR
    return str.replace(tSpan, '<span$1>$2</span>');
  },

  // Подсветить реакцию
  highlightReaction(id, container) {
    const reactionEl = document.getElementById(`reaction_${id}`);
    if (!reactionEl) return false;
    const getTop = (el) =>
      el.offsetTop + (el.offsetParent && getTop(el.offsetParent));
    container.scrollTo({ top: getTop(reactionEl), behavior: 'smooth' });
    setTimeout(() => reactionEl.classList.add('highlight'), 0);
    setTimeout(() => reactionEl.classList.remove('highlight'), 3000);
    return reactionEl;
  },

  getSelectedText() {
    let text = '';
    if (typeof window.getSelection !== 'undefined') {
      text = window.getSelection().toString();
    } else if (
      typeof document.selection !== 'undefined' &&
      document.selection.type === 'Text'
    ) {
      text = document.selection.createRange().text;
    }
    return text;
  },

  makeEventTitle(text) {
    if (!text || !text.length) return '';
    let title = Utils.removeHtmlTags(this.removeBbCode(this.divToN(text)));
    title = title.replace(/\n/g, ' ');
    let index = 0;
    const indexN = title.indexOf('\n');
    const indexDot = title.indexOf('.');
    if (indexDot !== -1) index = indexDot;
    if (indexN !== -1) index = indexN;
    if (indexN !== -1 && indexDot !== -1) index = Math.min(indexN, indexDot);
    if (!index) {
      return title.trim().replace(/(([^\s]+\s\s*){5})(.*)/, '$1'); // NOSONAR
    }
    return title.substring(0, index);
  },

  wrapSelectedRange({ el, id, start, end }) {
    const sel = window.getSelection();
    sel.removeAllRanges();
    // const node = el.firstChild;
    let node = el;
    while (node.hasChildNodes()) [node] = node.childNodes;
    // node.nodeValue = node.nodeValue.trim();
    const range = document.createRange();
    range.setStart(node, start);
    range.setEnd(node, end + 1);

    const span = document.createElement('span');
    span.id = id;

    range.surroundContents(span);
    sel.removeAllRanges();
    sel.addRange(range);
    return span;
  },

  unwrapRange(el) {
    const pa = el.parentNode;
    while (el.firstChild) {
      pa.insertBefore(el.firstChild, el);
    }
    el.remove();
  },

  getInnerHeight(elm) {
    const computed = getComputedStyle(elm);
    const padding =
      parseInt(computed.paddingTop, 10) + parseInt(computed.paddingBottom, 10);
    return elm.clientHeight - padding;
  },

  getRealHeight(elm) {
    let h = 0;
    for (const child of elm.childNodes) {
      h += this.getInnerHeight(child);
    }
    return h;
  },

  makeClearText(html) {
    const regBr = new RegExp('<br>', 'gi');
    const regSpan = new RegExp(
      '\\<span.*?\\>(.*?)\\<\\/span\\>\\&nbsp\\;', // NOSONAR
      'g'
    );
    return html.replace(regBr, '\n').replace(regSpan, '$1 ');
  },
};
